module.exports = __webpack_public_path__ + "img/stone-path-2.10109813.png";